module.exports = __webpack_public_path__ + "img/morningglow.435f0a4.webp";